export default __webpack_public_path__ + "static/media/Beautiful.83e67572.mp3";